import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function CompostIcon(props: IconProps) {
    return <Icon {...props} iconKey={"compost"}/>
}
